import React from 'react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-stone-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="font-serif text-2xl mb-4 text-white">
              DÉCORATION DE SOUSA FRÈRES
            </h3>
            <p className="text-stone-400 leading-relaxed mb-6">
              L'excellence en décoration et travaux de finition depuis 1965.
              Un savoir-faire artisanal transmis de génération en génération.
            </p>
            <p className="text-stone-500 text-sm">
              Créé en {companyInfo.foundedYear}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-medium text-lg mb-4">Navigation</h4>
            <ul className="space-y-3">
              {[
                { label: 'Accueil', id: 'hero' },
                { label: 'Notre Histoire', id: 'histoire' },
                { label: 'Savoir-faire', id: 'services' },
                { label: 'Pourquoi nous', id: 'pourquoi' },
                { label: 'Partenaires', id: 'partenaires' },
                { label: 'Contact', id: 'contact' }
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-stone-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Quick Info */}
          <div>
            <h4 className="font-medium text-lg mb-4">Contact</h4>
            <address className="not-italic text-stone-400 space-y-2">
              <p>6 rue du Pré de l'Hôpital</p>
              <p>94190 Villeneuve-Saint-Georges</p>
              <p>01 43 86 30 00</p>
            </address>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-stone-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-stone-500 text-sm">
            © {currentYear} DÉCORATION DE SOUSA FRÈRES. Tous droits réservés.
          </p>
          <button
            onClick={() => window.location.hash = 'admin'}
            className="text-stone-700 hover:text-stone-500 text-xs transition-colors"
          >
            Administration
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
